/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiAggregatedActivityMemes {
    'consolidation_key': string;
    'created_at': Date;
    'updated_at': Date;
    'primary_purchases_value': number;
    'primary_purchases_count': number;
    'secondary_purchases_value': number;
    'secondary_purchases_count': number;
    'burns': number;
    'sales_value': number;
    'sales_count': number;
    'airdrops': number;
    'transfers_in': number;
    'transfers_out': number;
    'season': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "consolidation_key",
            "baseName": "consolidation_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updated_at",
            "baseName": "updated_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "primary_purchases_value",
            "baseName": "primary_purchases_value",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "primary_purchases_count",
            "baseName": "primary_purchases_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "secondary_purchases_value",
            "baseName": "secondary_purchases_value",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "secondary_purchases_count",
            "baseName": "secondary_purchases_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "burns",
            "baseName": "burns",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sales_value",
            "baseName": "sales_value",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sales_count",
            "baseName": "sales_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "airdrops",
            "baseName": "airdrops",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "transfers_in",
            "baseName": "transfers_in",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "transfers_out",
            "baseName": "transfers_out",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "season",
            "baseName": "season",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiAggregatedActivityMemes.attributeTypeMap;
    }

    public constructor() {
    }
}
